import React, {Component} from "react";

export class DV360Logo extends Component {
    constructor(props) {
        super(props);
        this.state = {isHovered: false};
    }

    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getRenderVeryColoredVersion() {
        return !!this.props.renderVeryColoredVersion;
    }

    getIsColoredOnHover() {
        return !!this.props.isColoredOnHover;
    }

    handleMouseEnter = () => {
        this.setState({isHovered: true});
    }

    handleMouseLeave = () => {
        this.setState({isHovered: false});
    }

    render() {
        const showColored = this.getRenderVeryColoredVersion()
            || !this.getIsColoredOnHover()
            || this.state.isHovered;
        const containerStyle = {
            display: 'inline-block',
            marginLeft: this.getHSpace(),
            marginRight: this.getHSpace(),
            marginTop: this.getVSpace(),
            marginBottom: this.getVSpace(),
            filter: showColored ? 'none' : 'grayscale(100%) opacity(0.55)',
            ...this.props.styles
        };
        return (
            <span style={containerStyle} aria-label="Display & Video 360"
                  onMouseEnter={this.handleMouseEnter}
                  onMouseLeave={this.handleMouseLeave}>
                <svg xmlns="http://www.w3.org/2000/svg" width={this.getWidth()} height={this.getHeight()} viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="18" height="18" rx="4" fill="#4285F4"/>
                    <polygon points="10,8 16.5,12 10,16" fill="#FFFFFF"/>
                </svg>
            </span>
        );
    }
}
